module.exports = __webpack_public_path__ + "media/images/emblems/Goumoens-coat_of_arms-5aa30144e8d8a7a0d55c38962ef35d81.svg";